import {IoTreeNodeTypeModel} from './io-tree-node-type.model';
import {ITdoTreeItem} from '../../../tdo-controls/common/tdo-tree/models/i-tdo-tree-item';

export class IoTreeNodeModel implements ITdoTreeItem {
  id: string;
  name: string;
  documents?: any[];  // dataDocuments
  children: IoTreeNodeModel[] = [];
  parent?: IoTreeNodeModel;
  isExpanded: boolean;
  editMode: boolean;
  type: IoTreeNodeTypeModel;
  isPatientTree = false;
  matIconOverride: string = null;
}
